import axios, { CancelToken } from 'axios';
import { getToken } from "../../../token";
import { IGrupos } from '../../../../pages/ConfiguracoesReceitas/interface';
import { GATEWAY_API_URL } from "../../../request/urls";

class GruposReceitaService {
    async getGrupos(signal?: CancelToken) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/grupos`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data.sort((a: any, b: any) => Number(a.ordem) - Number(b.ordem));
    }

    async postGrupos(nome: string, signal?: CancelToken) {
        const { data } = await axios.post(`${GATEWAY_API_URL}/receitas-ipm/grupos`, { nome: nome }, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async updateGrupos(grupo_id: string, nome: string, signal?: CancelToken) {
        const { data } = await axios.patch(`${GATEWAY_API_URL}/receitas-ipm/grupos/${grupo_id}`, { nome: nome }, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async updateGruposOrdem(grupos: IGrupos[], signal?: CancelToken) {
        const { data } = await axios.patch(`${GATEWAY_API_URL}/receitas-ipm/grupos/ordem`, { grupos: grupos }, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async deleteGrupos(grupo_id: string, signal?: CancelToken) {
        const { data } = await axios.delete(`${GATEWAY_API_URL}/receitas-ipm/grupos/${grupo_id}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getSistemasGrupos(signal?: CancelToken) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/grupos/sistemas`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data.sort((a: any, b: any) => Number(a.ordem) - Number(b.ordem));
    }

    async postRepublicarSistemasGrupos(sistema: string, signal?: CancelToken) {
        const { data } = await axios.post(`${GATEWAY_API_URL}/receitas-ipm/grupos/republicar?sistema=${sistema}`, {}, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

}

export default new GruposReceitaService();
